export function formatKategorieTitle(kategorie) {
    if(kategorie === "Klimaschutz & Klimawandelanpassung") {
        return "Klimaschutz, Klimawandelanpassung und Luftreinhaltung"
    }
    return kategorie
}